import ApiService from "../api.service"

const AnnouncementService = {
  Get(id) {
    if (id == 0) {
      return ApiService.get(`/Announcement/Get`)
    } else {
      return ApiService.get(`/Announcement/Get/${id}`)
    }
  },
  GetList() {
    return ApiService.get(`/Announcement/GetList`)
  },
  GetNew() {
    return ApiService.get(`/Announcement/GetNew`)
  },
  Create(data) {
    return ApiService.post("/Announcement/Create", data)
  },
  Update(data) {
    return ApiService.post("/Announcement/Update", data)
  },
  Delete(id) {
    return ApiService.post(`/Announcement/Delete/${id}`)
  },
}
export default AnnouncementService
